<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='我的预约'">
    <div class="list" v-if="root&&root.length>0">
      <div class="item border-box" @click="toTeamDesc(item.ordernum)" v-for="(item,index) in root">
        <div class="item-t box">
          <div class="l flex bold hide">{{item.team}}</div>
          <div class="state" v-if="item.state==0">审核中</div>
          <div class="state" v-if="item.state==1">已通过</div>
          <div class="state" v-if="item.state==2">已拒绝</div>
          <div class="state" v-if="item.state==3">已取消</div>
        </div>
        <div class="item-m">
          <div class="box">
            <div class="l">经办人：</div>
            <div class="flex">{{item.name}}</div>
          </div>
          <div class="box">
            <div class="l">联系电话：</div>
            <div class="flex">{{item.phone}}</div>
          </div>
          <div class="box">
            <div class="l">提交时间：</div>
            <div class="flex">{{item.addtime}}</div>
          </div>
        </div>
        <div class="item-b border-box">
          <!--<div class="item-b-r fr btn tc disable" v-if="item.state==0">审核中</div>-->
          <!--<div class="item-b-r fr btn tc disable" v-if="item.state==1">已通过</div>-->
          <!--<div class="item-b-r fr btn tc disable" v-if="item.state==2">已拒绝</div>-->

          <div class="item-b-r fr btn tc line" @click.stop="toTeamDesc(item.ordernum)">查看详情</div>
          <div class="item-b-r fr btn tc line" @click.stop="toCancel(item.id,index)"  v-if="item.state==0||item.state==1" style="color: #333;border-color: #e3e3e3;">取消预约</div>
        </div>
      </div>
    </div>
    <div class="load-tip">
      <p>
        <span class="l"></span>
        <span class="m">{{loadText}}</span>
        <span class="r"></span>
      </p>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getTeamList,getCancel} from "@/service/getData";
  import {wxGetPosition,wxShareme, payMoney} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        loadText: "数据加载中",
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        orderState: '', //支付订单状态 10 待支付 11 取消支付 12 支付成功 13 超时取消 14 退款申请 15 退款成功
        type: '', //产品订单状态 1 未支付 2已支付(等待接单) 3拼团中 4待使用 5进行中 6待评价 7已完成 8游客取消 9景区取消
        page: 1, //加载更多
        pageSize:10,
        root:[],//订单列表
        P400: 0,//系统维护中
        currIndex:'',
        currId:''
      }
    },
    computed: {},

    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.getTeamListFun(this.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      async getTeamListFun(page){
        let res = await getTeamList({
          time: (new Date().getTime()),
          openid: this.userInfo.openid,
          pageNum: page,
          pageSize: this.pageSize,
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.total
          var root = res.data;
          if (page >= Math.ceil(this.total / this.pageSize)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.getTeamListFun(page);
          });
        })
      },

      //取消预约
      toCancel:function(id,index){
        var self = this;
        self.currIndex = index;
        self.currId = id;
        console.log(self.currId);
        this.$confirm({
          title: '提示',
          content: '确定取消当前预约吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.getCancelFun();
          }
        }).catch(function(res){
          if(res == 'success') {
            self.getCancelFun();
          }
        });
      },
      async getCancelFun(id){
        var self = this;
        let res = await getCancel({
          id: self.currId,
          time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          self.$alert({
            title: '提示',
            content: res.errmsg,
          });
          self.root[self.currIndex].state = 3;
        }else {
          self.$alert({
            title: '提示',
            content: res.errmsg,
          });
        }
      },


      toTeamDesc(ordernum){
        this.$router.push({
          path: `/order-team-desc?${'ordernum='+ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
    },
    watch: {},
    components: {
        P400
    }
  }

</script>

<style scoped>
  .page{min-height:100vh;padding: .24rem .3rem .4rem;background: #ededed;}
  .item{margin-top:.24rem;padding:0 .3rem;background: #fff;border-radius: .2rem;}
  .item:first-child{margin-top: 0;}
  .item .item-t{height:.84rem;font:.3rem/.84rem "Microsoft YaHei";color: #333;}
  .item .state{font:.24rem/.84rem "Microsoft YaHei";}
  .item-m{padding: .2rem 0 .3rem;border-top:1px solid #e3e3e3;font: .28rem/.46rem "Microsoft YaHei";color: #333;}
  .item-b{height: 1.02rem;border-top:1px solid #e3e3e3;}
  .item-b .btn{height: 0.62rem;margin-left: 0.12rem;margin-top: 0.18rem;text-align: center;font: .28rem/0.62rem "Microsoft YaHei";padding: 0 0.32rem;border: 1px solid #fd811e;}
  .item-b .btn.disable{background: #f3f3f3;}
  .btn.line{color: #fd811e;border-color: #fd811e;}
  .btn.disable{background: #f3f3f3;border-color: #f3f3f3;color: #666;}
</style>



// WEBPACK FOOTER //
// src/page/home/order-team-list.vue